import { actions as modalActions } from '../Modals';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import IconTrashcan from '@wix/da-ds/pkg/Icons/24x24/Trashcan';

export default ({ t, dispatch, willDestroyContent = false }) =>
  (onConfirm, confirmBtnBiData) => {
    dispatch(
      modalActions.pushConfirmationModal({
        title: t('widgets.common.removeWidget.header'),
        text: t(
          willDestroyContent
            ? 'widgets.common.removeWidget.body.danger'
            : 'widgets.common.removeWidget.body'
        ),
        confirmBtnLabel: t('widgets.common.removeWidget.confirmBtnLabel'),
        confirmBtnType: willDestroyContent ? 'danger' : 'default',
        confirmBtnBiData,
        cancelBtnLabel: t('widgets.common.removeWidget.cancelBtnLabel'),
        icon: <IconTrashcan size={IconSize.MEGA} />,
        onConfirm,
      })
    );
  };
